import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';

import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexYAxis,
  ApexDataLabels,
  ApexTooltip,
  ApexStroke
} from "ng-apexcharts";

@Component({
  selector: 'app-spline-area-chart',
  templateUrl: './spline-area-chart.component.html',
  styleUrls: ['./spline-area-chart.component.css']
})
export class SplineAreaChartComponent implements OnInit, OnChanges {

  chartOptions: {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
    yaxis: ApexYAxis;
    stroke: ApexStroke;
    tooltip: ApexTooltip;
    dataLabels: ApexDataLabels;
  };

    @Input()
    serie1: number[] = []

    @Input()
    serie2: number[] = []

    @Input()
    weeks: (number | string)[] = [];



  //@ViewChild("chart") chart: ChartComponent | undefined;
  //public chartOptions: Partial<ChartOptions>;

  constructor(
    public translate: TranslateService,
  ) {

    this.chartOptions = {
      series: [
        {
          name: "{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.ChartInfo.SeriesProgramLabel' | translate}}",
          data: this.serie1
        },
        {
          name: "{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.ChartInfo.SeriesLoadLabel' | translate}}",
          data: this.serie2
        }
      ],
      chart: {
        height: 245,
        type: "area"
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: "smooth"
      },
      yaxis: {
        title: {
          text: "Contenedores",
          style: {
            fontSize: '12px',
            fontWeight: 'nomral',
            color: 'rgba(0,0,0,0.38)',
          },
          offsetX:5
        },
        labels:{
          formatter: function (val){
            return val.toFixed(0)
          }
        }
      },
      xaxis: {
        type: "category",
        categories:this.weeks
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm"
        }
      }
    };
  }

  ngOnInit(): void {
    this.makeChart()
  }

  public generateData(baseval:any, count:any, yrange:any) {
    var i = 0;
    var series = [];
    while (i < count) {
      var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
      var y =
        Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
      var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;

      series.push([x, y, z]);
      baseval += 86400000;
      i++;
    }
    return series;
  }

  ngOnChanges(changes: SimpleChanges): void {
      if(changes['serie1'] || changes['serie2'] || changes['weeks'] ) {

        this.makeChart()
      }

  }

  makeChart()
  {
    const serie1 =  this.translate.instant('UserPages.UserClosedSale.ExporterClosedSaleOrders.ChartInfo.SeriesProgramLabel')
    const serie2 =  this.translate.instant('UserPages.UserClosedSale.ExporterClosedSaleOrders.ChartInfo.SeriesLoadLabel')
    const weekLabel =  this.translate.instant('UserPages.UserClosedSale.ExporterClosedSaleOrders.ChartInfo.WeekLabel')
    const axisYLabel =  this.translate.instant('UserPages.UserClosedSale.ExporterClosedSaleOrders.ChartInfo.AxisYLabel')

    if(this.serie1.length === 1)
      {
        this.serie1 = [...this.serie1 , ...this.serie1];
      }

      if(this.serie2.length === 1)
      {
        this.serie2 = [...this.serie2 , ...this.serie2];
      }

      if(this.weeks.length === 1){
        this.weeks = [...this.weeks , ...this.weeks];
      }

    const maxValueY = Math.ceil(Math.max(...this.serie1, ...this.serie2) + 1);

    this.chartOptions = {
      series: [
        {
          name: serie1,
          data: this.serie1
        },
        {
          name: serie2,
          data: this.serie2
        }
      ],
      chart: {
        height: 245,
        type: "area",
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: "smooth"
      },
      yaxis: {
        title: {
          text: "Contenedores",
          style: {
            fontSize: '12px',
            fontWeight: 'nomral',
            color: 'rgba(0,0,0,0.38)',
          },
          offsetX:8
        },
        labels:{
          formatter: function (val){
            return val.toFixed(0)
          }
        },
        max:maxValueY,
        min:0,
        //tickAmount: 5,       // Define el número de intervalos
      },
      xaxis: {
        type: "category",
        categories: this.weeks.map(item => {
          if (typeof item === 'number') {
            return weekLabel + " " + item;
          }

          return item;
        })
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm"
        }
      }
    };
  }
}
